
export const isHTML = function(contentString) {
    return new RegExp(/<\/?[a-z][\s\S]*>/i).test(contentString);
};
